import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowLeftIcon } from '../../assets/images/arrow-left.svg';

import {
  NavIconWrapper, TextContent, Wrapper,
} from './styles';
import {StyledTitle} from "../CustomAntdComponents/Typography";


type Props = {
  name?: string
  navigateHandler?: () => void
}

export const timelineSteps = [ 'Search', 'Passenger details', 'Overview and payment'];
export const roadTimelineSteps = [ 'Search', 'Seats selection', 'Passenger details', 'Overview and payment'];

function HeaderNavigation({ name, navigateHandler }: Props) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };
  return (
    <Wrapper>
      <NavIconWrapper onClick={handleNavigate}>
        <ArrowLeftIcon  width={15} height={15} />
      </NavIconWrapper>

      {name && (
      <TextContent>
        <StyledTitle level={4} align="center">{name}</StyledTitle>
      </TextContent>
      )}
    </Wrapper>
  );
}

HeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default HeaderNavigation;
